// removed by extract-text-webpack-plugin
module.exports = {"schoolhomepage-wrapper":"schoolhomepage-wrapper","homepage-url":"homepage-url","enable-on-yellowpage":"enable-on-yellowpage","show-homepage":"show-homepage","hide-homepage":"hide-homepage"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/SchoolHomepage/SchoolHomepage.scss
// module id = t2wX
// module chunks = 0